module.exports = require("./ff-Adlm-NE.d.ts");